import moment from 'moment';
import { sumArray } from './functionalUtils';

export const getPlayerInformation = (data) => {
  const shirtNumber = `#${data?.currentClub[0]?.shirtNumber}`;
  const currentTeam = data?.currentClub[0]?.name;
  const teamAbbrv = data?.teamAbbrv;
  const name = data?.displayName;
  const nationality = data?.nationality;
  const position = data?.position;
  const birthDate = data?.birthDate;
  const playerImage = data?.imageHalf200;

  const age = moment().diff(birthDate, 'years');

  const playerInformation = {
    shirtNumber,
    currentTeam,
    name,
    nationality,
    position,
    birthDate,
    age,
    playerImage,
    teamAbbrv,
  };

  return playerInformation;
};

export const getPlayerStats = (data) => {
  const playerStats = data.map((stat) => {
    const seasonYear =
      stat.seasonStartYear === stat.seasonEndYear
        ? stat.seasonStartYear
        : `${stat.seasonStartYear}/${stat.seasonEndYear}`;
    return {
      year: seasonYear,
      teamName: stat.teamName,
      leagueName: stat.league,
      matchesPlayed: stat.gameStats?.matches,
      matchesStarted: stat.gameStats?.matches - stat.gameStats?.subins,
      goals: stat.gameStats.goals,
      assists: stat.gameStats.assists,
      yellowCards: stat.gameStats.yellowCards,
      redCards: stat.gameStats.redCards,
    };
  });

  return playerStats;
};

export const getPlayerCurrentSeasonStats = (data) => {
  const currentSeasonStatsRaw = data?.stats.filter(
    (stat) =>
      Number(stat.seasonStartYear) === Number(data?.configLeagueStartYear) &&
      stat.league.toLowerCase() === data?.configLeagueName.toLowerCase()
  );

  const currentSeasonStats =
    currentSeasonStatsRaw?.length > 0
      ? {
          goals: sumArray(
            currentSeasonStatsRaw?.map((stat) => Number(stat?.gameStats?.goals))
          ),
          matchesPlayed: sumArray(
            currentSeasonStatsRaw?.map((stat) =>
              Number(stat?.gameStats?.matches)
            )
          ),
          matchesStarted: sumArray(
            currentSeasonStatsRaw?.map(
              (stat) =>
                Number(stat?.gameStats?.matches) -
                Number(stat?.gameStats?.subins)
            )
          ),
          assists: sumArray(
            currentSeasonStatsRaw?.map((stat) =>
              Number(stat?.gameStats?.assists)
            )
          ),
        }
      : {
          goals: 0,
          matchesPlayed: 0,
          matchesStarted: 0,
          assists: 0,
        };

  return currentSeasonStats;
};
